import React, { useState, useRef, useContext } from 'react';

import './css/searchBar.css';
import filters from '../../data/layouts/filters';
import LoadingBox from '../compoment/LoadingBox';
import MessageBox from '../compoment/MessageBox';
import { useNavigate } from 'react-router-dom';
import { Store } from '../../Store';
import FilterInput from './compoment/FilterInput';
import useInfoFilters from '../../data/layouts/useInfo';
import useIsDevice from '../../format/useIsDevice';

const SearchBar = () => {
  const navigate = useNavigate();

  const { state, dispatch: ctxDispatch } = useContext(Store);
  const { totalSearch } = state;

  const [open, setOpen] = useState(false);

  const [formValues, setFormValues] = useState([]);
  const [resetKey, setResetKey] = useState(0);

  const [showFilterAdvanced, setShowFilterAdvanced] = useState(false);
  const [maxHeight, setMaxHeight] = useState(0);

  const advancedRef = useRef(null);

  const { loading, error, filtersSearch } = useInfoFilters();

  const isTablet = useIsDevice(0, 991);
  const limitTablet = isTablet;

  const handleToggle = (id) => {
    setOpen((prevOpen) => (prevOpen === id ? null : id));
  };

  const handleToggleAdvanced = () => {
    setShowFilterAdvanced((prev) => {
      const next = !prev;
      if (next && advancedRef.current) {
        const scrollHeight = advancedRef.current.scrollHeight;
        setMaxHeight(scrollHeight);
      }
      return next;
    });
  };

  const handleChange = (keyword, value, mode) => {
    setFormValues((prev) => {
      const foundIndex = prev.findIndex((item) => item.keyword === keyword);

      if (mode === 'REMOVE') {
        if (foundIndex === -1) return prev;

        const currentValues = prev[foundIndex].value.split(',').filter(Boolean);

        const filtered = currentValues.filter((v) => v !== value.toString());

        if (filtered.length === 0) {
          return prev.filter((item) => item.keyword !== keyword);
        }

        return prev.map((item, index) =>
          index === foundIndex ? { ...item, value: filtered.join(',') } : item
        );
      }

      if (foundIndex !== -1) {
        if (value) {
          return prev.map((item, index) =>
            index === foundIndex
              ? mode === true
                ? {
                    ...item,
                    value: `${item.value},${value}`
                      .split(',')
                      .filter((v, i, arr) => v && arr.indexOf(v) === i)
                      .join(','),
                  }
                : { ...item, value }
              : item
          );
        } else {
          return prev.filter((item) => item.keyword !== keyword);
        }
      } else {
        return [...prev, { keyword, value: value.toString() }];
      }
    });
  };

  const handleSubmit = () => {
    const breadcrumb = [
      {
        title: 'Thành viên',
        slug: '/thanh-vien',
      },
    ];
    ctxDispatch({
      type: 'SET_BREADCRUMB',
      payload: breadcrumb,
    });
    localStorage.setItem('resentBread', JSON.stringify(breadcrumb));
    const queryString = formValues
      .map((item) => `${item.keyword}=${item.value}`)
      .join('&');

    navigate(`/search?${queryString}`);
  };

  const getFilterValue = (keyword) =>
    formValues.find((f) => f.keyword === keyword)?.value || '';

  const handleReset = () => {
    setFormValues([]);
    setResetKey((prev) => prev + 1);
  };

  return loading ? (
    <LoadingBox />
  ) : error ? (
    <MessageBox variant="danger"> {error} </MessageBox>
  ) : (
    <div className="content-show bg-search">
      <div className="container my-3">
        <div className="d-search-basic">
          <div className="form-group first-group">
            <div className="left-cell cell">
              <img
                src="/images/icon_search/programmer.png"
                alt=""
                className="icon"
              />
              <input
                type="text"
                name="keyword"
                className="box-search"
                style={{ padding: '0 0.5rem' }}
                placeholder="Tìm theo MSSV, Họ và tên, SĐT,..."
                value={
                  formValues.find((key) => key.keyword === 'keyword')?.value ||
                  ''
                }
                onChange={(e) => handleChange('keyword', e.target.value)}
                onKeyDown={(e) => {
                  if (e.key === 'Enter') {
                    e.preventDefault(); // tránh form reload nếu trong form
                    handleSubmit();
                  }
                }}
              />
            </div>

            {!limitTablet && (
              <div className="right-cell">
                <FilterInput
                  item={filtersSearch[1]}
                  isOpen={open}
                  onToggle={handleToggle}
                  value={getFilterValue(filtersSearch?.[1]?.keyword)}
                  onChange={handleChange}
                />
              </div>
            )}
          </div>

          {!limitTablet && (
            <FilterInput
              item={filtersSearch[6]}
              isOpen={open}
              onToggle={handleToggle}
              value={getFilterValue(filtersSearch?.[6]?.keyword)}
              onChange={handleChange}
            />
          )}

          <button
            className="form-group cell btn-search"
            onClick={handleSubmit}
            onTouchEnd={(e) => {
              e.preventDefault();
              handleSubmit();
            }}
          >
            <img
              className="icon"
              src="/images/icons/search.png"
              alt="Tìm bạn"
            />
            <span className="px-1">Tìm bạn</span>
          </button>
        </div>

        <div className="d-flex d-search-desc">
          <div className="label-search">
            <span
              style={{
                fontWeight: '700',
                color: 'var(--mint)',
                marginRight: '0.5rem',
              }}
            >
              {totalSearch}
            </span>{' '}
            <span>Kết quả</span>
          </div>
          <div className="ms-auto d-flex gap-20">
            <div className="label-search" onClick={handleReset}>
              <img
                className="icon mx-1"
                src="/images/icons/undo.png"
                alt="Reset"
              />
              Reset
            </div>

            <button
              className="label-search d-flex "
              onClick={handleToggleAdvanced}
            >
              <img
                className="icon"
                src="/images/icons/filter.png"
                alt="Tìm kiếm"
              />
              <span style={{ padding: '0 0.5rem' }}>Lọc nâng cao</span>
              <img
                className={`ms-auto icon-arrow ${
                  showFilterAdvanced ? 'rotate-180' : ''
                } `}
                alt=""
                src="/images/icons/arrow-down-white.png"
              />
            </button>
          </div>
        </div>

        <div
          className={`search-advanced ${showFilterAdvanced ? 'showing' : ''}`}
          style={{
            maxHeight: showFilterAdvanced ? `${maxHeight}px` : '0px',
          }}
        >
          <div className="d-search-advanced" ref={advancedRef}>
            {filtersSearch.slice(2, 6).map((item) => (
              <FilterInput
                key={`${item.id}-${resetKey}`}
                item={item}
                isOpen={open}
                onToggle={() => handleToggle(item.id)}
                value={getFilterValue(item.keyword)}
                onChange={handleChange}
              />
            ))}
            <FilterInput
              item={filtersSearch[0]}
              isOpen={open}
              onToggle={handleToggle}
              value={getFilterValue(filtersSearch?.[0]?.keyword)}
              onChange={handleChange}
            />
            {filtersSearch.slice(7, filtersSearch.length).map((item) => (
              <FilterInput
                key={`${item.id}-${resetKey}`}
                item={item}
                isOpen={open}
                onToggle={() => handleToggle(item.id)}
                value={getFilterValue(item.keyword)}
                onChange={handleChange}
              />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default SearchBar;
